'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var startAnimationName = 'onAutofillStart';
var endAnimationName = 'onAutofillCancel';
var styleElementId = 'autofill-style';
var counterAttribute = 'data-counter';

var isWebkit = function isWebkit() {
  return navigator.userAgent.indexOf('WebKit') !== -1;
};

function emptyAnimation(animationName) {
  return '\n    @keyframes ' + animationName + ' {\n      from {/**/}\n      to {/**/}\n    }\n  ';
}

function injectKeyFrames() {
  var autofillStartEmptyKeyframesStyle = emptyAnimation(startAnimationName);
  var autofillEndEmptyKeyframesStyle = emptyAnimation(endAnimationName);

  injectStyle(autofillStartEmptyKeyframesStyle);
  injectStyle(autofillEndEmptyKeyframesStyle);
}

function injectStyle(style) {
  var styleSheet = document.getElementById(styleElementId).sheet;

  try {
    styleSheet.insertRule(style, styleSheet.cssRules.length);
  } catch (err) {
    console.warn('style injection failed');
  }
}

function injectAutofillHook() {
  // Expose a hook for JavaScript when autofill is shown.
  // JavaScript can capture 'animationstart' events
  // Change the backgound color _really slowly_
  var autofillHook = '\n    input:-webkit-autofill {\n      animation-name: ' + startAnimationName + ';\n      transition: background-color 50000s ease-in-out 0s;\n    }\n  ';

  // Expose a hook for JavaScript when autofill is no longer shown.
  // JavaScript can capture 'animationstart' events
  var notAutofillHook = '\n    input:not(:-webkit-autofill) {\n      animation-name: ' + endAnimationName + ';\n    }';

  injectStyle(autofillHook);
  injectStyle(notAutofillHook);
}

function registerAutofill() {
  if (!isWebkit()) return;

  var autofillStyle = document.getElementById(styleElementId);

  if (!autofillStyle) {
    autofillStyle = document.createElement('style');
    autofillStyle.id = styleElementId;
    autofillStyle.setAttribute(counterAttribute, 0);
    document.head.appendChild(autofillStyle);

    injectKeyFrames();
    injectAutofillHook();
  }

  var usageCounter = autofillStyle.getAttribute(counterAttribute);
  usageCounter++;
  autofillStyle.setAttribute(counterAttribute, usageCounter);
}

function unregisterAutofill() {
  if (!isWebkit()) return;

  var autofillStyle = document.getElementById(styleElementId);
  var usageCounter = autofillStyle.getAttribute(counterAttribute);
  usageCounter--;
  autofillStyle.setAttribute(counterAttribute, usageCounter);

  if (usageCounter === 0) {
    // remove element
    autofillStyle.outerHTML = '';
  }
}

exports.default = function (autofillProps) {
  return function (Target) {
    var WithAutofillProps = function (_Component) {
      _inherits(WithAutofillProps, _Component);

      function WithAutofillProps() {
        _classCallCheck(this, WithAutofillProps);

        var _this = _possibleConstructorReturn(this, (WithAutofillProps.__proto__ || Object.getPrototypeOf(WithAutofillProps)).call(this));

        _this.state = { autofill: false };
        _this.handleAnimation = _this.handleAnimation.bind(_this);
        return _this;
      }

      _createClass(WithAutofillProps, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          registerAutofill();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          unregisterAutofill();
        }
      }, {
        key: 'handleAnimation',
        value: function handleAnimation(e) {
          switch (e.animationName) {
            case startAnimationName:
              if (this.props.onAutofill) {
                this.props.onAutofill();
              }

              return this.setState({ autofill: true });

            case endAnimationName:
              if (this.props.onEndAutofill) {
                this.props.onEndAutofill();
              }
              return this.setState({ autofill: false });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var autofill = this.state.autofill;


          return _react2.default.createElement(Target, _extends({
            onAnimationStart: this.handleAnimation
          }, this.props, autofill && autofillProps));
        }
      }]);

      return WithAutofillProps;
    }(_react.Component);

    WithAutofillProps.displayName = (0, _wrapDisplayName2.default)(Target, 'withAutofillProps');

    return WithAutofillProps;
  };
};